<div class="splash-screen">
  <div class="spinner"></div> <!-- Loading animation or splash screen -->
</div>
